import * as React from 'react';
import styled, { css } from 'styled-components';

import type { FlexProps } from 'common/components/FlexContainer';
import { createFlexStyles } from 'common/components/FlexContainer';

type Props = FlexProps & {
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  inline?: boolean;
} & Pick<React.HTMLProps<HTMLDivElement>, 'id' | 'onClick' | 'onMouseEnter' | 'onMouseLeave'>;

const Root = styled.div<Props>`
  margin: 0;
  ${(props) => createFlexStyles(props)}

  /* web specific overrides */
  ${({ inline }) =>
    inline &&
    css`
      display: inline-flex;
    `}
`;

const FlexContainerBase = (props: Props, ref: React.Ref<HTMLDivElement>) => (
  <Root {...props} ref={ref}>
    {props.children && props.children}
  </Root>
);

const FlexContainer = React.forwardRef(FlexContainerBase);

export default FlexContainer;
